import styled from '@emotion/styled';

export const StepContainer = styled.div`
    margin: 12px;
`;
